<template>
  <div>
    <Head title="Create Campaign" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/campaigns">Campaigns</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <!-- Organization Select -->
          <label for="organization">Organization:</label>
          <select v-model="form.organization_id" name="organization" required>
            <option value="" disabled>Select an organization</option>
            <option v-for="organization in organizations" :key="organization.id" :value="organization.id">
              {{ organization.name }}
            </option>
          </select>
          <text-input v-model="form.ref" :error="form.errors.ref" class="pb-8 pr-6 w-full lg:w-1/2" label="Ref" />
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/2" label="Description" />
          <select-input v-model="form.campaign_step" :error="form.errors.campaign_step" class="pb-8 pr-6 w-full lg:w-1/2" label="Campaign Step">
            <option :value="null" />
            <option value="parent">Parent campaign</option>
            <option value="plan">Plan</option>
            <option value="implementation">Implementation/ Distribution</option>
            <option value="check">Check</option>
            <option value="retrieve">Retrieve</option>
            <option value="report">Report Stage</option>
          </select-input>
          <select-input v-model="form.campaign_type" :error="form.errors.campaign_type" class="pb-8 pr-6 w-full lg:w-1/2" label="Campaign Type">
            <option :value="null" />
            <option value="drop">Drop and Retrieve/ Check</option>
            <option value="flyer">Drop Only/ Flyer</option>
            <option value="cs">Community Saturation campaign</option>
          </select-input>
          <select-input v-model="form.resolver_type" :error="form.errors.resolver_type" class="pb-8 pr-6 w-full lg:w-1/2" label="Resolver Type">
            <option :value="null" />
            <option value="full">Resolve nearest home address if available</option>
            <option value="street">Only nearest street name if available</option>
          </select-input>
          <text-input v-model="form.budget" :error="form.errors.budget" class="pb-8 pr-6 w-full lg:w-1/2" label="Budget" />
          <select-input v-model="form.active" :error="form.errors.active" class="pb-8 pr-6 w-full lg:w-1/2" label="Active">
            <option :value="null" />
            <option value="1">Active</option>
            <option value="0">Archive/Hide</option>
          </select-input>
          <select-input v-model="form.negotiation" :error="form.errors.negotiation" class="pb-8 pr-6 w-full lg:w-1/2" label="Negotiation">
            <option :value="null" />
            <option value="1">Active</option>
            <option value="0">Archive/Hide</option>
          </select-input>
          <select-input v-model="form.approved" :error="form.errors.approved" class="pb-8 pr-6 w-full lg:w-1/2" label="Approved">
            <option :value="null" />
            <option value="1">Active</option>
            <option value="0">Archive/Hide</option>
          </select-input>
          <select-input v-model="form.deployed" :error="form.errors.deployed" class="pb-8 pr-6 w-full lg:w-1/2" label="Deployed">
            <option :value="null" />
            <option value="1">Active</option>
            <option value="0">Archive/Hide</option>
          </select-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Campaign</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        account_id: 1,
        organization_id: 1,
        parent_id: 0,
        ref: null,
        name: null,
        description: null,
        campaign_step: 'parent',
        campaign_type: 'drop',
        resolver_type: 'full',
        budget: 0,
        active: 1,
        negotiation: 0,
        approved: 0,
        deployed: 0,
      }),
      organizations: [],
    }
  },
  created() {
    this.$inertia
      .remember(
        'organizations', // Key to store data
        this.$inertia.get('/app/v1/fetch-organizations')
      )
      .then(response => {
        this.organizations = response;
      });
  },
  methods: {
    store() {
      this.form.post('/admin/campaigns')
    },
  },
}
</script>
